import { render, staticRenderFns } from "./LeftNavigationDrawer.vue?vue&type=template&id=348cf978&scoped=true&"
import script from "./LeftNavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./LeftNavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavigationDrawer.vue?vue&type=style&index=0&id=348cf978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348cf978",
  null
  
)

export default component.exports